import { createSelector } from 'reselect';
import checkFeatureFlag from 'utils/featureFlags';
import { getStreakBadges } from '../utils';
export const selectIsStreaksScreenEnabled = (store) => checkFeatureFlag(store.utils.featureFlags, 'streaks_screen_ab');
export const selectStreaksSummary = (store) => store.streaks.summary;
export const selectStreaksMonth = (store, month) => store.streaks.months[month];
// The settings tile reads the streak from the user, which is always loaded
export const selectUserDayStreak = (store) => store.user.user.dayStreak ?? 0;
export const selectStreakBadges = createSelector([(store) => store.streaks.summary?.longestStreak.days ?? 0], getStreakBadges);
